import React from "react";
import Service from "./Service";

const Services = () => {
  const elements = [
    {
      title: "Web development",
      description: "Website programming for the positioning of your business.",
      icon: "ti-desktop",
    },
    {
      title: "Mobile Development",
      description: "Develop your application for any mobile device",
      icon: "ti-mobile",
    },
    {
      title: "Cloud",
      description: "Cloud storage systems to manage your information",
      icon: "ti-cloud",
    },
    {
      title: "Security",
      description:
        "Optimize your software to protect it from different threats that can affect your systems.",
      icon: "ti-lock",
    },
  ];
  const services = [];

  for (const [index, value] of elements.entries()) {
    services.push(
      <Service
        key={index}
        title={value.title}
        description={value.description}
        icon={value.icon}
      />,
    );
  }

  return (
    <>
      <section
        id={"services"}
        className={"section g-bg-gray p-0px-t section-top-up-100"}
      >
        <div className={"container"}>
          <div className={"row"}>{services}</div>
        </div>
      </section>
    </>
  );
};

export default Services;
